<!-- Divider -->
<div
    class="treo-horizontal-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
